// How a snippet authenticates with the Loyalty Engine's v5 snippet APIs: the snippet session key the merchant's
// server put in the snippet args, or - TEMPORARILY, until connectors create snippet sessions - the bLoyal cart Uid,
// with the snippet's login domain and device code in headers. Remove the cart Uid fallback once every page passes a
// SnippetSessionKey. Undefined when the page gave neither, and the v5 snippet APIs can't be called.
export type SnippetAuth = {
	apiKey: string,
	headers?: Record<string, string>,
}

export function snippetAuth(snippetSessionKey: string, cartUid: string, domain: string, deviceCode: string): SnippetAuth | undefined {
	if (snippetSessionKey)
		return {apiKey: snippetSessionKey}

	if (cartUid)
		return {apiKey: cartUid, headers: {'x-bloyal-login-domain': domain, 'x-bloyal-device-code': deviceCode}}

	return undefined
}

// TEMPORARY, with the cart Uid fallback: the eGift snippet on a page with no cart yet sends only its login domain and
// device code. The Loyalty Engine's first eGift save then creates the cart, and the snippet passes that cart's Uid from
// then on. Undefined when the page names no device either.
export function newCartAuth(domain: string, deviceCode: string): SnippetAuth | undefined {
	if (!domain || !deviceCode)
		return undefined

	return {apiKey: '', headers: {'x-bloyal-login-domain': domain, 'x-bloyal-device-code': deviceCode}}
}
